export const states = {
    config: "Config",
    userInfo: "Account_Info"
}

export const stateEvents = {
    signOut: "SignOut",
    refreshConfig: "RefreshConfig"
}